class Pagination {
    constructor() {
        this.defaultOptions = {
            screen_reader_text: "",
            aria_label: "",
            type: "link" // link o button
        };
    }

    /**
     * @param {URL|string} url
     * @param {int} total_items
     * @param {int} items_per_page
     * @param {int} current_page
     * @param {Object} options
     * @returns {string}
     */
    render(url, total_items, items_per_page, current_page, options) {
        total_items = parseInt(total_items, 10);
        items_per_page = parseInt(items_per_page, 10);
        current_page = parseInt(current_page, 10);

        options = Object.assign({}, this.defaultOptions, options);

        let page_tag = "button" === options.type ? "button" : "a";
        let page_attr = "button" === options.type ? "data-url" : "href";
        let total_pages = Math.ceil(total_items / items_per_page);

        if (total_pages <= 1) {
            return "";
        }

        let pages = [1, current_page, total_pages]; // prima pagina, pagina corrente e ultima pagina

        // pagine intermedie
        for (let i = 0; i <= 2; i++) {
            pages.push(current_page + i);
            pages.push(current_page - i);
        }

        // Filtro i valori fuori range
        pages = pages.filter(page => page >= 1 && page <= total_pages);

        // Filtro i valori duplicati
        pages = pages.filter((page, index, array) => array.indexOf(page) === index);

        // Ordinamento
        pages.sort((a, b) => a - b);

        // Ok, iniziamo a comporre il codice HTML
        let pagination = "";
        let i = 1;
        let href = new URL(url.toString());

        pages.forEach(page => {
            if (i !== page) {
                pagination += `<span class="page-numbers dots">…</span>`;
                i = page;
            }

            if (page === current_page) {
                pagination += `<span aria-current="page" class="page-numbers current">${i}</span>`;
            } else {
                href = this.#createUrl(href, page);

                pagination += `<${page_tag} class="page-numbers" ${page_attr}="${href.toString()}">${i}</${page_tag}>`;
            }

            i++;
        });

        if (current_page > 1) {
            let prev_url = this.#createUrl(href, current_page - 1);
            let prev_icon = `<svg role="img" focusable="false"><use xlink:href="${m6e.spriteUrl}#icon--arrow"></use></svg>`;
            let prev_link = `<${page_tag} class="prev page-numbers" ${page_attr}="${prev_url}">${prev_icon}<span class="sr-only">Pagina precedente</span></${page_tag}>`;

            pagination = prev_link + pagination;
        }

        if (current_page < total_pages) {
            let next_url = this.#createUrl(href, current_page + 1);
            let next_icon = `<svg role="img" focusable="false"><use xlink:href="${m6e.spriteUrl}#icon--arrow"></use></svg>`;
            let next_link = `<${page_tag} class="next page-numbers" ${page_attr}="${next_url}">${next_icon}<span class="sr-only">Pagina successiva</span></${page_tag}>`;

            pagination = pagination + next_link;
        }

        let screen_reader_text = options.screen_reader_text ? `<h2 class="screen-reader-text">${options.screen_reader_text}</h2>` : "";
        let aria_label = options.aria_label ? ` aria-label="${options.aria_label}"` : "";

        return `<nav class="navigation c-pagination"${aria_label}>${screen_reader_text}<div class="nav-links">${pagination}</div></nav>`;
    }

    /**
     * @param {URL} url
     * @param {int} page
     * @returns {URL}
     */
    #createUrl(url, page) {
        if (1 === page) {
            url.searchParams.delete("pag");
        } else {
            url.searchParams.set("pag", page.toString());
        }

        return url;
    }
}

export default Pagination;
